import Controller from "./mapPoint.controller";
import template from "./mapPoint.html";

const mapPoint = {
  template,
  controller: Controller,
  bindings: {
    title: "@",
    point: "<",
  },
};

export default mapPoint;



// WEBPACK FOOTER //
// ./src/components/mapPoint/mapPoint.component.js